import React, { useState } from 'react';
import { useLazyDocumentationFilesQuery } from '../../../graphql/graphql';

export default function useDocumentationFiles() {
	const [getDocumentationFilesQuery, { data, isLoading }] =
		useLazyDocumentationFilesQuery();
	const [page, setPage] = useState(1);
	const getDocumentationFiles = (userId?: string, filter?: string) => {
		getDocumentationFilesQuery({
			userId,
			fulltext: filter,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getDocumentationFiles, getNextPage, data, isLoading, page, setPage };
}
